module.exports = __webpack_public_path__ + "static/media/1.fb10b2bc.png";